import React from "react";
import styles from "./StudentNameComponent.module.css";
import Avatar from "@mui/material/Avatar";

const StudentNameComponent = (props) => {
  // props: studentName, profilePic
  return (
    <div className={styles.name_container}>
      <Avatar
        // sx={{ width: 48, height: 48 }}
        sx={{
          width: {
            xs: 35, // theme.breakpoints.up('xs')
            sm: 48, // theme.breakpoints.up('sm')
          },
          height: {
            xs: 35, // theme.breakpoints.up('xs')
            sm: 48, // theme.breakpoints.up('sm')
          },
        }}
        className={styles.avatar}
        src={props.profilePic}
      />
      <span className={styles.student_name}>{props.studentName}</span>
    </div>
  );
};

export default StudentNameComponent;
